jQuery(document).ready(function($){
	if(typeof acf == 'undefined')
		return;
	acf.add_filter('validation_complete', function( json, form ){
		if(json.errors==0)
			return json;
		
		for(var i in json.errors)
		{
			if(json.errors[i].input=="goto?login=1")
			{
				json.errors[i].input="";
				$('.login-register .login-form').slideDown();
				$('.login-register .register-form').slideUp();
			}
			if(json.errors[i].input=="goto?register=1")
			{
				json.errors[i].input="";
				$('.login-register .register-form').slideDown();
				$('.login-register .login-form').slideUp();
			}
			if(json.errors[i].input=='captcha')
			{
				json.errors[i].input="";
				grecaptcha.reset();
			}
		}
		return json;
	}, 20 );

  //aded custom color pallet to picker 
  acf.add_filter('color_picker_args', function( args, field ){
    //                blush   , lilac,   , taupe,     black
    args.palettes = ['#C38473', '#A18496','#C1A890', '#000000', ]
    return args;
  });
});